<div class="reason-textarea" [ngClass]="customClass">
  <label class="label">{{ label | translate }}</label>
  <textarea
    [formControl]="control"
    [placeholder]="placeholder | translate"
    class="textarea"
    rows="4"
  ></textarea>
</div>
